// extracted by mini-css-extract-plugin
module.exports = {"sharedStyles":"\"../../themes/sharedStyles.module.css\"","subcaption":"SubCaption_subcaption__3EEIu sharedStyles_standardTextStructure__2HVr-"};